<div class="color-picker__container d-flex flex-row align-items-center">
  <div class="color-picker-input" [class.me-2]="showTextInput()">
    <input
      [style.background]="value"
      [(colorPicker)]="value"
      [cpOKButton]="true"
      [cpOKButtonClass]="'cpOKButton'"
      [cpOutputFormat]="'hex'"
      [cpAlphaChannel]="'disabled'"
      [disabled]="ngControl?.control.disabled || disabled()"
      [required]="required()"
      (colorPickerChange)="onValueChanges($event)"
      readonly
    />
  </div>
  @if (showTextInput()) {
    <div class="color-text position-relative">
      <input
        type="text"
        appAutofocus="{{ autoFocus() }}"
        [(ngModel)]="value"
        (ngModelChange)="onValueChanges($event)"
        class="form-control"
        [placeholder]="'forms.pick_a_color' | translate"
        [disabled]="ngControl?.control.disabled"
        [required]="required()"
      />
      @if (value && !ngControl?.control.disabled) {
        <i
          class="icon icon--close color-picker-clear-icon"
          (click)="clearColor()"
        ></i>
      }
    </div>
  }
</div>
@if (description()) {
  <div
    class="default-s color-picker-description"
    [innerHTML]="description()"
  ></div>
}
